/**
 * Simple asset preloader composable
 */
export function useAssetPreloader() {
  /**
   * Preload an image
   */
  function preloadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(src);
      img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
      img.src = src;
    });
  }

  /**
   * Preload a video
   */
  function preloadVideo(src) {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.onloadeddata = () => resolve(src);
      video.onerror = () => reject(new Error(`Failed to load video: ${src}`));
      video.src = src;
      video.load();
    });
  }

  /**
   * Preload multiple assets
   */
  async function preloadAssets(assets) {
    const promises = assets.map((src) => {
      if (/\.(mp4|webm|ogg)$/i.test(src)) {
        return preloadVideo(src);
      } else {
        return preloadImage(src);
      }
    });

    try {
      await Promise.all(promises);
      console.log("Assets preloaded successfully:", assets);
    } catch (error) {
      console.warn("Some assets failed to preload:", error);
    }
  }

  return {
    preloadAssets,
    preloadImage,
    preloadVideo,
  };
}
